import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { Card } from "../../lib/components/ui/card";
import Layout from "../layout";

export default function Privacy() {
	const { t } = useTranslation();

	const sections = [
		"information_collection",
		"how_we_use",
		"information_sharing",
		"data_security",
		"your_rights",
		"contact",
	];

	return (
		<Layout>
			<div className="p-4 md:p-8 border-none md:border rounded-none md:rounded-large bg-gradient-main min-h-full">
				<div className="max-w-4xl mx-auto">
					<motion.div
						initial={{ opacity: 0, y: -20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.25, ease: "easeOut" }}
						className="text-center mb-8 md:mb-12"
					>
						<h1 className="text-2xl md:text-3xl font-manrope font-semibold mb-3 md:mb-4">
							{t("legal.privacy.title")}
						</h1>
						<p className="text-muted-foreground text-sm md:text-base">
							{t("legal.privacy.last_updated")}
						</p>
					</motion.div>

					<motion.div
						initial={{ opacity: 0, y: 20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.25, delay: 0.05, ease: "easeOut" }}
						className="mb-6"
					>
						<Card className="p-4 md:p-6">
							<p className="text-muted-foreground leading-relaxed">
								{t("legal.privacy.introduction")}
							</p>
						</Card>
					</motion.div>

					<div className="space-y-6">
						{sections.map((section, index) => (
							<motion.div
								key={section}
								initial={{ opacity: 0, y: 20 }}
								animate={{ opacity: 1, y: 0 }}
								transition={{
									duration: 0.25,
									delay: 0.1 + index * 0.05,
									ease: "easeOut",
								}}
							>
								<Card className="p-4 md:p-6">
									<h2 className="text-lg md:text-xl font-semibold mb-3 md:mb-4">
										{t(`legal.privacy.sections.${section}.title`)}
									</h2>
									<p className="text-muted-foreground leading-relaxed">
										{t(`legal.privacy.sections.${section}.content`)}
									</p>
								</Card>
							</motion.div>
						))}
					</div>
				</div>
			</div>
		</Layout>
	);
}
